import cn from "classnames";
import useOnClickOutside from "hooks/useOnClickOutside";
import { t } from "i18next";
import { useRef } from "react";

import { TableItemActionsModalProps } from "./TableItemActionsModal.types";

import styles from "./TableItemActionsModal.module.scss";

const TableItemActionsModal = ({
  handleClose,
  actionsList,
  className,
  hideDisabled = false
}: TableItemActionsModalProps) => {
  const optionsRef = useRef(null);

  useOnClickOutside(optionsRef, handleClose);

  return (
    <div ref={optionsRef} className={cn(styles.options, className)}>
      {actionsList.map(
        ({ Icon, label, value, onClick, labelColor, disabled }) =>
          hideDisabled && disabled ? null : (
            <button
              key={label}
              className={styles.optionBtn}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onClick?.(value);
              }}
              disabled={disabled}
            >
              {Icon}
              <span
                style={{
                  color: disabled ? "#a8a8bb" : (labelColor ?? "#090914")
                }}
              >
                {t(label)}
              </span>
            </button>
          )
      )}
    </div>
  );
};

export default TableItemActionsModal;
